import SlimSelect from 'slim-select';
import type { Settings, Events, Option } from 'slim-select';

export type SelectWithSlim = HTMLSelectElement & { slim: SlimSelect };

export class CustomSelect {
  private readonly nativeSelect: HTMLSelectElement;

  constructor(target: HTMLSelectElement) {
    this.nativeSelect = target;
  }

  init(): void {
    const label = this.nativeSelect.labels?.[0] ?? null;
    const labelText = label?.textContent?.trim() ?? null;

    new SlimSelect({
      select: this.nativeSelect,
      settings: {
        showSearch: false,
        showContent: 'down',
        closeOnSelect: true,
        ariaLabel: labelText || undefined,
      } as Partial<Settings>,
      events: {
        afterChange: (selected: Option[]) => {
          const event = new CustomEvent('slim:change', {
            bubbles: true,
            detail: {
              selected,
            },
          });
          this.nativeSelect.dispatchEvent(event);
        },
      } as Events,
    });
  }
}

export function initCustomSelects(root: ParentNode = document): void {
  root.querySelectorAll<HTMLSelectElement>('.custom-select').forEach((select) => {
    const customSelect = new CustomSelect(select);
    customSelect.init();
  });
}
